import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../../i18n/config';
import { useTranslation } from 'react-i18next';
import axios from "axios";
import logo from '../../logo.svg';
import { requestResetPassword, resetPassword, whoami } from '../../services/user';
import { User } from '../../interfaces/user';
import Footer from '../general/footer';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import moment from 'moment';

export interface LoginProps {
    onLoginSuccess: CallableFunction
}

export default function Login(props: LoginProps) {
    const { t } = useTranslation();
    const searchParams = useLocation().search;
    const navigate = useNavigate();

    const [doResetPassword, setDoResetPassword] = useState(false);
    const [doRequestResetPassword, setDoRequestResetPassword] = useState(false);
    const [passwordMessage, setPasswordMessage] = useState('');
    const [repeatPasswordMessage, setRepeatPasswordMessage] = useState('');
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');

    useEffect(() => {
        const h = new URLSearchParams(searchParams).get('h');
        if (h) {
            const h_decoded = atob(h);
            const h_values = h_decoded.split('|||');
            if (h_values[0] !== undefined && h_values[1] != undefined && h_values[2] != undefined && h_values[3] != undefined) {
                if (moment(h_values[2] + ' ' + h_values[3]) < moment().add(5, 'minutes')) {
                    setUserId(h_values[0]);
                    setDoResetPassword(true);
                }
            }
        }
    }, []);

    const handleSubmit = (event: any) => {
        event.preventDefault();
        
        let data = JSON.stringify({
            "username": event.target.username.value,
            "password": event.target.password.value
        });

        let config = {
            method: 'post',            
            url: process.env.REACT_APP_API_BASE_URL + '/wp-json/jwt-auth/v1/token',
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };

        axios.request(config)
            .then((response: any) => {
                const newState = {
                    user: {
                        id: 0,
                        username: '',
                        firstName: '',
                        email: response.data.user_email,
                        token: response.data.token
                    }
                }
                // setState((prev) => ({ ...prev, ...newState }));
                localStorage.setItem('token', newState.user.token);
                whoami()
                    .then((whoamiResponse: any) => {
                        const userProfile: User = {
                            id: whoamiResponse.data.id,
                            name: whoamiResponse.data.name,
                            email: whoamiResponse.data.user_email,
                            first_name: whoamiResponse.data.firstname,
                            last_name: whoamiResponse.data.surname,
                            birthdate: whoamiResponse.data.birthdate,
                            phone: whoamiResponse.data.phone,
                            document_id: whoamiResponse.data.document_id,
                            description: whoamiResponse.data.description,
                            slug: whoamiResponse.data.slug,
                            role: whoamiResponse.data.role,
                            // meta: whoamiResponse.data.meta.map((m: any) => { return m; }),
                            avatar: whoamiResponse.data.avatar,
                            club: whoamiResponse.data.club,
                            teams: whoamiResponse.data.teams,
                            status: whoamiResponse.data.status
                        }
                        if (userProfile.status == 0) {
                            alert(t("Check your credentials or ask your superior. Yo are not allowed to login now."))
                            localStorage.removeItem('token');
                        } else {
                            props.onLoginSuccess(userProfile);
                        }
                    })
                    .catch(whoamiError => {
                        console.log(whoamiError);
                    });
        })
        .catch((error) => {
            alert(t("user_login_bad_credentials"));
        });
    }

    const handlePasswordChange = (event: any) => {
        const val = event.currentTarget.value;
        setPassword(val);
        if (val.length < 8) {
            setPasswordMessage(t("Password must be at least 8 characters long."));
        } else {
            setPasswordMessage('');
        }
    }

    const handleRepeatPasswordChange = (event: any) => {
        const val = event.currentTarget.value;
        if (val != password) {
            setRepeatPasswordMessage(t("The passwords entered do not match."));
        } else {
            setRepeatPasswordMessage('');
        }
    }

    const handleResetSubmit = (event: any) => {
        event.preventDefault();
        
        resetPassword(userId, password)
            .then((response: any) => {
                if (response.data.status == -1) {
                    alert(response.data.message);
                } else {
                    setDoResetPassword(false);
                    setPasswordMessage('');
                    setRepeatPasswordMessage('');
                    setUserId('');
                    setPassword('');
                    setDoRequestResetPassword(false);
                    alert(t("Password changed. Continue to login."));
                    navigate('/');
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleRequestResetPassword = (event: any) => {
        event.preventDefault();
        setDoRequestResetPassword(true);
    }

    const handleRequestResetSubmit = (event: any) => {
        event.preventDefault();
        
        requestResetPassword(event.target.email.value)
            .then((response: any) => {
                if (response.data.status == -1) {
                    alert(response.data.message);
                } else {
                    setDoResetPassword(false);
                    setPasswordMessage('');
                    setRepeatPasswordMessage('');
                    setUserId('');
                    setPassword('');
                    alert(t("Check your inbox to read the reset password instructions email."));
                    setDoRequestResetPassword(false);
                    navigate('/');
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleBackToLogin = (event: any) => {
        event.preventDefault();
        setDoResetPassword(false);
        setPasswordMessage('');
        setRepeatPasswordMessage('');
        setUserId('');
        setPassword('');
        setDoRequestResetPassword(false);
    } 

    return (
        <div className="login-outer-container">
            <Container>
                <Row>
                    <Col>
                        { !doResetPassword && !doRequestResetPassword &&
                            <div className="login-container">
                                <div className="inner">
                                    <div className="logo">
                                        <img alt="Badminton" src= {logo}/>
                                    </div>
                                    <div className="welcome">
                                        { t("welcome") }
                                    </div>
                                    <Form onSubmit={ handleSubmit }>
                                        <div className="fields mt-3">
                                            <Form.Group className="mb-3" controlId="username">
                                                <Form.Label>{ t("email") }</Form.Label>
                                                <Form.Control type="email" placeholder={ t("write_your_email") } required />
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="password">
                                                <Form.Label>{ t("password") }</Form.Label>
                                                <Form.Control type="password" placeholder={ t("write_your_password") } required />
                                            </Form.Group>
                                        </div>
                                        <div className="actions">
                                            <Button variant="primary" type="submit">
                                                { t("login") }
                                            </Button>
                                        </div>
                                        <div className="other-actions">
                                            <div className="forgot-password">
                                                { t("forgot_password_question") }<br />
                                                <a href="#" title={ t("reset_password") } onClick={ handleRequestResetPassword }>
                                                    { t("reset_password") }
                                                </a>
                                            </div>    
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        }
                        { doResetPassword &&
                            <div className="reset-password-container">
                                <div className="inner">
                                    <div className="logo">
                                        <img alt="Badminton" src= {logo}/>
                                    </div>
                                    <div className="welcome">
                                        { t("Reset your password") }
                                    </div>
                                    <Form onSubmit={ handleResetSubmit }>
                                        <div className="fields mt-3">
                                             <Form.Group className="mb-3" controlId="password">
                                                <Form.Label>{ t("password") }</Form.Label>
                                                <Form.Control type="password" placeholder={ t("write_your_password") } 
                                                    name="password" required onChange={ handlePasswordChange } />
                                                { passwordMessage.length > 0 &&
                                                    <div className="message">
                                                        { passwordMessage }
                                                    </div>
                                                }
                                            </Form.Group>
                                             <Form.Group className="mb-3" controlId="password_repeat">
                                                <Form.Label>{ t("Repeat password") }</Form.Label>
                                                <Form.Control type="password" placeholder={ t("write_your_password") }
                                                    name="password_repeat" required onChange={ handleRepeatPasswordChange } />
                                                { repeatPasswordMessage.length > 0 &&
                                                    <div className="message">
                                                        { repeatPasswordMessage }
                                                    </div>
                                                }
                                            </Form.Group>
                                        </div>
                                        <div className="actions">
                                            <Button variant="primary" type="submit">
                                                { t("Reset") }
                                            </Button>
                                        </div>
                                        <div className="other-actions">
                                            <div className="forgot-password">
                                                <a href="#" title={ t("Back to login") } onClick={ handleBackToLogin }>
                                                    { t("Back to login") }
                                                </a>
                                            </div>    
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        }
                        { doRequestResetPassword &&
                            <div className="request-reset-password-container">
                                <div className="inner">
                                    <div className="logo">
                                        <img alt="Badminton" src= {logo}/>
                                    </div>
                                    <div className="welcome">
                                        { t("Send a link to reset password") }
                                    </div>
                                    <Form onSubmit={ handleRequestResetSubmit }>
                                        <div className="fields mt-3">
                                             <Form.Group className="mb-3" controlId="email">
                                                <Form.Label>{ t("email") }</Form.Label>
                                                <Form.Control type="email" placeholder={ t("write_your_email") } 
                                                    name="email" required />
                                            </Form.Group>
                                        </div>
                                        <div className="actions">
                                            <Button variant="primary" type="submit">
                                                { t("Reset") }
                                            </Button>
                                        </div>
                                        <div className="other-actions">
                                            <div className="forgot-password">
                                                <a href="#" title={ t("Back to login") } onClick={ handleBackToLogin }>
                                                    { t("Back to login") }
                                                </a>
                                            </div>    
                                        </div>
                                    </Form>
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
            </Container>
            <Footer />
        </div>
    );
}
